/* Boitoi — product page behaviour: key-facts arrows, "See all details", Frequently bought together,
   and the sticky page menu. Loaded once from sections/product-details-tabs.liquid. */
(function () {
  if (window.BoitoiPDP) return;
  var PDP = (window.BoitoiPDP = {});
  var NAV_H = 48;

  /* ---------- helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function formatMoney(cents, fmt) {
    fmt = fmt || 'Rs. {{amount}}';
    function withDelims(n, prec, thou, dec) {
      var parts = (n / 100).toFixed(prec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts[0] + (parts[1] ? dec + parts[1] : '');
    }
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var v;
    switch (m && m[1]) {
      case 'amount_no_decimals': v = withDelims(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = withDelims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = withDelims(cents, 0, '.', ','); break;
      default: v = withDelims(cents, 2, ',', '.');
    }
    return m ? fmt.replace(m[0], v) : v;
  }

  /* Height of whatever is fixed/sticky at the top of the screen (the site header), so our bar and
     scroll targets sit just below it. */
  var navEl = null;
  function headerBottom() {
    var max = 0;
    var els = document.elementsFromPoint ? document.elementsFromPoint(Math.round(window.innerWidth / 2), 2) : [];
    for (var i = 0; i < els.length && i < 6; i++) {
      var n = els[i];
      if (navEl && navEl.contains(n)) continue;
      while (n && n !== document.body && n !== document.documentElement) {
        var pos = getComputedStyle(n).position;
        if (pos === 'fixed' || pos === 'sticky') {
          var r = n.getBoundingClientRect();
          if (r.top <= 2 && r.height < 260 && r.bottom > max) max = r.bottom;
          break;
        }
        n = n.parentElement;
      }
    }
    return Math.max(0, Math.round(max));
  }
  function scrollToEl(el) {
    if (!el) return;
    var top = el.getBoundingClientRect().top + window.pageYOffset - (headerBottom() + NAV_H + 8);
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  /* Open a product-details tab (description / author / details / toc) and scroll to it. */
  PDP.openTab = function (kind) {
    var head = $('.m-tab-header[data-bx-tab="' + kind + '"]');
    var tabs = document.getElementById('bx-tabs');
    if (head) head.click();
    scrollToEl(tabs || head);
    return !!head;
  };

  /* ---------- key-facts strip ---------- */
  function initKeyFacts() {
    $all('[data-bx-kf]').forEach(function (box) {
      var track = $('[data-bx-kf-track]', box);
      var prev = $('[data-bx-kf-prev]', box);
      var next = $('[data-bx-kf-next]', box);
      if (!track) return;
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        if (prev) prev.hidden = track.scrollLeft <= 2;
        if (next) next.hidden = track.scrollLeft >= max - 2;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-bx-open-tab]');
      if (!a) return;
      e.preventDefault();
      PDP.openTab(a.getAttribute('data-bx-open-tab'));
    });
  }

  /* ---------- frequently bought together ---------- */
  function readJSON(el, fallback) {
    try { return el ? JSON.parse(el.textContent) : fallback; } catch (e) { return fallback; }
  }
  function fetchRecs(pid, intent) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var url = root + 'recommendations/products?product_id=' + pid + '&limit=8&intent=' + intent + '&section_id=boitoi-fbt-recs';
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return [];
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return readJSON(doc.querySelector('[data-bx-fbt-recs]'), []);
      })
      .catch(function () { return []; });
  }
  function currentVariantId(fallback) {
    var input = $('.m-product-form--main form [name="id"]') || $('form[action*="/cart/add"] [name="id"]');
    var v = input && parseInt(input.value, 10);
    return v || fallback;
  }

  function initFbt() {
    var box = $('[data-bx-fbt]');
    if (!box) return Promise.resolve();
    var main = readJSON($('[data-bx-fbt-main]', box), null);
    var picks = readJSON($('[data-bx-fbt-manual]', box), []);
    var fmt = box.getAttribute('data-money-format');
    if (!main) return Promise.resolve();

    function uniq(list) {
      var seen = {}; seen[main.pid] = 1;
      return list.filter(function (p) { if (!p || seen[p.pid]) return false; seen[p.pid] = 1; return true; });
    }
    var chain = Promise.resolve(uniq(picks));
    chain = chain.then(function (list) {
      if (list.length >= 2) return list;
      return fetchRecs(main.pid, 'complementary').then(function (c) { return uniq(list.concat(c)); });
    }).then(function (list) {
      if (list.length >= 2) return list;
      return fetchRecs(main.pid, 'related').then(function (c) { return uniq(list.concat(c)); });
    });

    return chain.then(function (list) {
      list = list.slice(0, 2);
      if (!list.length) { box.remove(); return; }
      render([main].concat(list));
      box.hidden = false;
      document.dispatchEvent(new CustomEvent('bx:fbt-ready'));
    });

    function render(items) {
      var body = $('[data-bx-fbt-body]', box);
      var imgs = items.map(function (p, i) {
        return (i ? '<span class="bx-fbt__plus" aria-hidden="true">+</span>' : '') +
          '<a class="bx-fbt__img" href="' + esc(p.url) + '" data-i="' + i + '">' +
          (p.img ? '<img src="' + esc(p.img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>';
      }).join('');
      var rows = items.map(function (p, i) {
        return '<li><label><input type="checkbox" checked data-i="' + i + '">' +
          '<span>' + (i === 0 ? '<strong>This item:</strong> ' + esc(p.title) : '<a href="' + esc(p.url) + '">' + esc(p.title) + '</a>') + '</span>' +
          ' <span class="bx-fbt__price">' + esc(formatMoney(p.price, fmt)) + '</span>' +
          (p.cmp > p.price ? ' <s class="bx-fbt__cmp">' + esc(formatMoney(p.cmp, fmt)) + '</s>' : '') +
          '</label></li>';
      }).join('');
      body.innerHTML =
        '<div class="bx-fbt__top"><div class="bx-fbt__imgs">' + imgs + '</div>' +
        '<div class="bx-fbt__buy"><div class="bx-fbt__total">Total price: <strong data-total></strong></div>' +
        '<button type="button" class="bx-fbt__btn" data-add></button><div class="bx-fbt__msg" data-msg role="status"></div></div></div>' +
        '<ul class="bx-fbt__list" role="list">' + rows + '</ul>';

      var boxes = $all('input[type="checkbox"]', body);
      var btn = $('[data-add]', body);
      var total = $('[data-total]', body);
      var msg = $('[data-msg]', body);
      function chosen() { return boxes.filter(function (b) { return b.checked; }).map(function (b) { return items[+b.getAttribute('data-i')]; }); }
      function update() {
        var sel = chosen();
        var sum = sel.reduce(function (s, p) { return s + p.price; }, 0);
        total.textContent = formatMoney(sum, fmt);
        btn.disabled = !sel.length;
        btn.textContent = sel.length === 3 ? 'Add all 3 to Cart' : sel.length === 2 ? 'Add both to Cart' : sel.length === 1 ? 'Add to Cart' : 'Choose an item';
        $all('.bx-fbt__img', body).forEach(function (a) {
          var b = boxes[+a.getAttribute('data-i')];
          a.classList.toggle('is-off', !(b && b.checked));
        });
      }
      boxes.forEach(function (b) { b.addEventListener('change', update); });
      update();

      btn.addEventListener('click', function () {
        var sel = chosen();
        if (!sel.length) return;
        msg.textContent = '';
        btn.disabled = true;
        var list = sel.map(function (p) { return { id: p === items[0] ? currentVariantId(p.id) : p.id, quantity: 1 }; });
        var sections = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } }));
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(root + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: list, sections: sections, sections_url: window.location.pathname })
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res && res.status) {
              msg.textContent = res.description || res.message || 'Sorry, these items could not be added.';
              return;
            }
            try {
              if (window.MinimogEvents && window.MinimogTheme) {
                window.MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, { cart: res, productVariantId: list[0].id });
              }
            } catch (e) {}
            var drawer = document.querySelector('m-cart-drawer');
            var settings = window.MinimogSettings || {};
            if (drawer && settings.enable_cart_drawer !== false && typeof drawer.open === 'function') {
              drawer.open();
            } else {
              window.location.href = (settings.routes && settings.routes.cart) || '/cart';
            }
            document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: res } }));
          })
          .catch(function () { msg.textContent = 'Sorry, something went wrong. Please try again.'; })
          .finally(function () { btn.disabled = false; update(); });
      });
    }
  }

  /* ---------- sticky page menu ---------- */
  function initNav() {
    navEl = $('[data-bx-pnav]');
    if (!navEl) return;
    var links = $('[data-bx-pnav-links]', navEl);
    var buy = $('.m-product-form--main') || $('.m-main-product--info');
    var tabs = document.getElementById('bx-tabs');
    var items = [];

    function tabHead(kind) { return $('.m-tab-header[data-bx-tab="' + kind + '"]'); }
    function build() {
      var defs = [];
      var about = document.getElementById('bx-about-item');
      if (about) defs.push({ label: 'About this item', el: about });
      var fbt = document.getElementById('bx-fbt');
      if (fbt && !fbt.hidden) defs.push({ label: 'Bought together', el: fbt });
      var ap = $('.bx-aplus');
      if (ap) { var h = $('.bx-aplus__title', ap); defs.push({ label: h ? h.textContent.trim() : 'From the Publisher', el: ap }); }
      [['description', null], ['author', 'About the Author'], ['toc', null], ['details', 'Product details']].forEach(function (t) {
        var hd = tabHead(t[0]);
        if (hd) defs.push({ label: t[1] || hd.textContent.trim(), tab: t[0], el: tabs || hd });
      });
      Array.prototype.forEach.call(document.querySelectorAll('.bpm'), function (more) {
        var mt = $('.bpm__title', more);
        defs.push({ label: more.getAttribute('data-bx-nav') || (mt ? mt.textContent.trim() : 'More'), el: more });
      });
      var recs = $('.shopify-section[id$="__product-recommendations"]');
      if (recs && recs.offsetHeight > 40) defs.push({ label: 'Similar', el: recs });

      links.innerHTML = defs.map(function (d, i) { return '<a href="#" data-k="' + i + '">' + esc(d.label) + '</a>'; }).join('');
      items = defs;
      spy();
    }

    links.addEventListener('click', function (e) {
      var a = e.target.closest('a[data-k]');
      if (!a) return;
      e.preventDefault();
      var d = items[+a.getAttribute('data-k')];
      if (!d) return;
      if (d.tab) PDP.openTab(d.tab); else scrollToEl(d.el);
    });
    $all('[data-bx-top]', navEl).forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); });
    });

    function spy() {
      var off = headerBottom() + NAV_H + 24;
      var active = -1;
      items.forEach(function (d, i) {
        if (!d.el || !d.el.isConnected) return;
        var r = d.el.getBoundingClientRect();
        if (r.top <= off && r.bottom > off - 10) {
          if (d.tab) {
            var hd = tabHead(d.tab);
            if (hd && hd.classList.contains('active')) active = i;
          } else {
            active = i;
          }
        }
      });
      $all('a[data-k]', links).forEach(function (a) {
        var on = +a.getAttribute('data-k') === active;
        a.classList.toggle('is-active', on);
        if (on && a.scrollIntoView && links.scrollWidth > links.clientWidth) {
          var lr = links.getBoundingClientRect(), ar = a.getBoundingClientRect();
          if (ar.left < lr.left || ar.right > lr.right) links.scrollLeft += ar.left - lr.left - 24;
        }
      });
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var hb = headerBottom();
        navEl.style.setProperty('--bx-pnav-top', hb + 'px');
        var show = buy ? buy.getBoundingClientRect().bottom < hb : window.pageYOffset > 600;
        navEl.classList.toggle('is-on', show);
        if (show) spy();
      });
    }

    navEl.hidden = false;
    build();
    document.addEventListener('bx:fbt-ready', build);
    window.addEventListener('load', build);
    setTimeout(build, 2500);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  function init() {
    initKeyFacts();
    initNav();
    initFbt();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();